import styled, { keyframes } from "styled-components";
import theme from "../theme";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Bone = styled.div`
  background: linear-gradient(
    90deg,
    ${theme.cardBorder} 25%,
    ${theme.bgAlt}      50%,
    ${theme.cardBorder} 75%
  );
  background-size: 600px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: ${(p) => p.$r || "6px"};
  width: ${(p) => p.$w || "100%"};
  height: ${(p) => p.$h || "12px"};
  flex-shrink: 0;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;
  margin-bottom: 36px;
`;

const Meta = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
`;

const StatsRow = styled.div`display: flex; gap: 32px; margin-top: 8px;`;

const StatBlock = styled.div`display: flex; flex-direction: column; gap: 6px;`;

const TabRow = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 2px solid ${theme.separator};
  margin-bottom: 28px;
  padding-bottom: 12px;
`;

export default function ProfileSkeleton() {
  return (
    <>
      <Header>
        {/* avatar */}
        <Bone $w="130px" $h="130px" $r="16px" />

        <Meta>
          {/* role label */}
          <Bone $w="60px" $h="10px" />
          {/* name */}
          <Bone $w="200px" $h="28px" $r="8px" />
          {/* institution */}
          <Bone $w="120px" $h="12px" />
          {/* bio */}
          <Bone $h="12px" />
          <Bone $w="70%" $h="12px" />

          <StatsRow>
            {[80, 90, 90, 100].map((w, i) => (
              <StatBlock key={i}>
                <Bone $w={`${w}px`} $h="22px" $r="6px" />
                <Bone $w="50px" $h="10px" />
              </StatBlock>
            ))}
          </StatsRow>
        </Meta>
      </Header>

      {/* tabs */}
      <TabRow>
        <Bone $w="80px" $h="12px" $r="4px" style={{ marginRight: 24 }} />
        <Bone $w="60px" $h="12px" $r="4px" />
      </TabRow>
    </>
  );
}
